import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ruku",
  "use": "icon-ruku-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ruku\"><defs><style type=\"text/css\"></style></defs><path d=\"M920 355.2L531.2 77.6c-11.2-8-26.4-8-36.8 0L104 355.2c-12.8 8.8-6.4 28.8 9.6 28.8H192v496c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V384h78.4c15.2 0 21.6-20 9.6-28.8zM640 768H384v-64h256v64z m0-128H384v-64h256v64z m0-128H384v-64h256v64z\" p-id=\"3852\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ruku.svg
// module id = hXFO
// module chunks = 87